<ng-template #labelTemplate>
  <label
    *ngIf="labelChild"
    class="form-field-label gap-1"
    [attr.for]="formFieldControl?.id"
    [attr.aria-owns]="formFieldControl?.id"
  >
    <ng-content select="app-form-label" />
    <span *ngIf="formFieldControl?.required" class="required-asterik">*</span>
    <ng-content select="[appFormLabelSuffix]" />
  </label>
</ng-template>

<div #textField class="form-field-wrapper">
  <div
    [class.form-field-float]="appearance !== 'legacy'"
    [class.form-field-float--always]="floatLabel === 'always'"
  >
    <div *ngIf="appearance === 'legacy'">
      <ng-template [ngTemplateOutlet]="labelTemplate"></ng-template>
    </div>

    <div>
      <ng-template [ngIf]="appearance !== 'legacy'">
        <ng-template [ngTemplateOutlet]="labelTemplate"></ng-template>
      </ng-template>

      <ng-content></ng-content>
    </div>
  </div>
  <ng-content select="app-form-error" />
</div>
